import { helpCommand } from "@/commands/command/help-command";
import { args } from "@/lib/args/args";
import { out } from "@/lib/output/out";
import { VERSION } from "@/lib/version/version-constants";
import { wantsJson } from "@/lib/wants/wants-json";
import { dispatch } from "@/dispatch";
export async function main(): Promise<void> {
  const argv = process.argv.slice(2);
  out.setJson(wantsJson(argv));

  const [command, ...rest] = argv;

  if (!command || command === "help" || command === "--help") {
    helpCommand();
    return;
  }

  // Answered early, but NOT before the arguments are checked: returning ahead
  // of the parser would exempt this command from the strictness every other one
  // applies.
  if (command === "--version" || command === "-v" || command === "version") {
    args.expect(args.parse(rest), {});
    if (out.isJson()) {
      out.json({ version: VERSION });
    } else {
      out.line(VERSION);
    }
    return;
  }

  await dispatch(command, rest);
}
